/**
 * ExtractionQualityMeter - Display extraction confidence with progress bar
 */

interface ExtractionQualityMeterProps {
  confidence: number; // 0-100 percentage
  fieldCount?: number;
  flaggedFieldCount?: number;
  className?: string;
}

export function ExtractionQualityMeter({
  confidence,
  fieldCount,
  flaggedFieldCount = 0,
  className = "",
}: ExtractionQualityMeterProps) {
  const percentage = Math.round(confidence);

  // Determine quality description based on confidence
  const getQualityDescription = () => {
    if (percentage >= 90) {
      return `High confidence extraction${fieldCount ? ` across ${fieldCount} fields` : ""}.${flaggedFieldCount > 0 ? ` ${flaggedFieldCount} fields require manual validation.` : ""}`;
    }
    if (percentage >= 75) {
      return `Good confidence extraction.${flaggedFieldCount > 0 ? ` ${flaggedFieldCount} fields require review.` : " Review low-confidence fields."}`;
    }
    return `Manual review recommended.${flaggedFieldCount > 0 ? ` ${flaggedFieldCount} fields flagged for attention.` : ""}`;
  };

  return (
    <div
      className={`rounded-xl border border-slate-200 bg-slate-50/50 p-4 dark:border-slate-800 dark:bg-slate-900/50 ${className}`}
    >
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-xs font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400">
          Extraction Quality
        </h3>
        <span className="text-sm font-bold text-primary">{percentage}%</span>
      </div>
      <div className="h-1.5 w-full rounded-full bg-slate-200 dark:bg-slate-700 overflow-hidden">
        <div
          className="h-full bg-primary transition-all duration-300"
          style={{ width: `${percentage}%` }}
        />
      </div>
      <p className="mt-2 text-[11px] text-slate-500 dark:text-slate-400">
        {getQualityDescription()}
      </p>
    </div>
  );
}

export default ExtractionQualityMeter;
